"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsPDFGeneration = void 0;
require("jspdf-autotable");
const jspdf_autotable_1 = require("jspdf-autotable");
const payments_pdf_generation_1 = require("../constants/payments-pdf-generation");
const payment_pdf_util_1 = require("../util/payments/payment-pdf.util");
const transform_data_1 = require("../util/payments/transform-data");
class PaymentsPDFGeneration {
}
exports.PaymentsPDFGeneration = PaymentsPDFGeneration;
PaymentsPDFGeneration.formatPaymentConfirmationToPDFBlob = (paymentSummary, customers, fileName, returnType = "BLOB") => {
    try {
        const doc = (0, payment_pdf_util_1.createDoc)(fileName, "l");
        customers.forEach((customer) => {
            const customerHeader = (0, payment_pdf_util_1.composeCustomerConfirmationHeader)(customer);
            const customerInvoicesRows = (0, payment_pdf_util_1.composeInvoiceConfirmationRows)(customer);
            (0, jspdf_autotable_1.default)(doc, {
                head: customerHeader,
                body: customerInvoicesRows,
                startY: doc.previousAutoTable.finalY ?? 85,
                theme: "grid",
                margin: {
                    horizontal: 13,
                    top: 85,
                    bottom: 25,
                },
                rowPageBreak: "avoid",
                headStyles: {
                    fillColor: payments_pdf_generation_1.PAYMENTS_GREY,
                    halign: "center",
                    textColor: "#FFFFFF",
                },
                styles: {
                    cellWidth: 60,
                    fontSize: 7,
                    textColor: payments_pdf_generation_1.PAYMENTS_BLACK,
                    valign: "middle",
                },
                willDrawPage: (data) => {
                    if (data.table.startPageNumber < data.pageNumber) {
                        data.table.head.splice(0, 1);
                    }
                },
            });
        });
        const createCustomTable = () => {
            (0, payment_pdf_util_1.createPaymentConfirmationHeaderTable)(doc, paymentSummary);
        };
        (0, payment_pdf_util_1.createHeader)(doc, "PAYMENT CONFIRMATION", createCustomTable);
        (0, payment_pdf_util_1.createFooter)(doc);
        return returnType === "BLOB" ? doc.output("blob") : doc;
    }
    catch (e) {
        console.error(e);
        throw new Error();
    }
};
PaymentsPDFGeneration.formatAllInvoicesToPDFBlob = (transactions, dateLabel, fileName, title, returnType = "BLOB") => {
    try {
        const doc = (0, payment_pdf_util_1.createDoc)(fileName, "l");
        const pageWidth = doc.internal.pageSize.getWidth();
        const margins = 26;
        const availableWidth = pageWidth - margins;
        const columnProportions = {
            customer: 0.185,
            transaction: 0.11,
            customerPO: 0.1,
            orderNumber: 0.085,
            dateIssued: 0.085,
            amount: 0.085,
            amountDue: 0.085,
            dueDate: 0.085,
            status: 0.085,
        };
        const bodyTableHeader = [
            [
                { content: "Customer" },
                { content: "Transaction" },
                { content: "Customer PO" },
                { content: "Order Number" },
                { content: "Date Issued" },
                { content: "Amount" },
                { content: "Amount Due" },
                { content: "Due Date" },
                { content: "Status" },
            ],
        ];
        const bodyRows = transactions.map((transaction) => {
            return [
                `${transaction.customerName} #${transaction.customerNumber}`,
                `Invoice #${transaction.transactionNumber}`,
                transaction.customerPO,
                transaction.orderNumber ? transaction.orderNumber + "" : "",
                transform_data_1.TransformData.formatDateCustom(transaction.issueDate),
                transform_data_1.TransformData.numberToUSDString(transaction.amount),
                transform_data_1.TransformData.numberToUSDString(transaction.amountDue),
                transform_data_1.TransformData.formatDateCustom(transaction.dueDate),
                transaction.status,
            ];
        });
        (0, jspdf_autotable_1.default)(doc, {
            head: bodyTableHeader,
            body: bodyRows,
            startY: doc.previousAutoTable.finalY ?? 85,
            theme: "grid",
            margin: {
                horizontal: 13,
                top: 85,
                bottom: 25,
            },
            rowPageBreak: "avoid",
            headStyles: {
                fillColor: payments_pdf_generation_1.PAYMENTS_GREY,
                halign: "center",
                textColor: "#FFFFFF",
                valign: "middle",
            },
            styles: {
                fontSize: 7,
                textColor: payments_pdf_generation_1.PAYMENTS_BLACK,
                valign: "middle",
            },
            columnStyles: {
                0: {
                    cellWidth: availableWidth * columnProportions.customer,
                    halign: "left",
                },
                1: {
                    cellWidth: availableWidth * columnProportions.transaction,
                    halign: "center",
                },
                2: {
                    cellWidth: availableWidth * columnProportions.customerPO,
                    halign: "center",
                },
                3: {
                    cellWidth: availableWidth * columnProportions.orderNumber,
                    halign: "center",
                },
                4: {
                    cellWidth: availableWidth * columnProportions.dateIssued,
                    halign: "center",
                },
                5: {
                    cellWidth: availableWidth * columnProportions.amount,
                    halign: "center",
                },
                6: {
                    cellWidth: availableWidth * columnProportions.amountDue,
                    halign: "center",
                },
                7: {
                    cellWidth: availableWidth * columnProportions.dueDate,
                    halign: "center",
                },
                8: {
                    cellWidth: availableWidth * columnProportions.status,
                    halign: "center",
                },
            },
            willDrawPage: (data) => {
                if (data.table.startPageNumber < data.pageNumber) {
                    data.table.head.splice(0, 1);
                }
            },
        });
        const createCustomerHeaderTable = () => {
            (0, payment_pdf_util_1.createAllInvoicesHeaderTable)(doc, dateLabel);
        };
        (0, payment_pdf_util_1.createHeader)(doc, title, createCustomerHeaderTable);
        (0, payment_pdf_util_1.createFooter)(doc);
        return returnType === "BLOB" ? doc.output("blob") : doc;
    }
    catch (e) {
        console.error(e);
        throw new Error();
    }
};
PaymentsPDFGeneration.formatPaymentActivityToPDFBlob = (payments, dateLabel, fileName, returnType = "BLOB") => {
    try {
        const doc = (0, payment_pdf_util_1.createDoc)(fileName);
        const bodyTableHeader = [
            [
                { content: "Reference #" },
                { content: "Payment Method" },
                { content: "Payment Date" },
                { content: "# of Items" },
                { content: "# of Customers" },
                { content: "Payment Amount" },
                { content: "Status" },
            ],
        ];
        const bodyRows = payments.map((payment) => {
            return [
                `#${payment.referenceNumber}`,
                payment.paymentMethod,
                transform_data_1.TransformData.formatDateCustom(payment.paymentDate),
                `${payment.itemCount}`,
                `${payment.customerCount}`,
                transform_data_1.TransformData.numberToUSDString(payment.totalPaymentAmount),
                payment.status,
            ];
        });
        (0, jspdf_autotable_1.default)(doc, {
            head: bodyTableHeader,
            body: bodyRows,
            startY: doc.previousAutoTable.finalY ?? 85,
            theme: "grid",
            margin: {
                horizontal: 13,
                top: 85,
                bottom: 25,
            },
            rowPageBreak: "avoid",
            headStyles: {
                fillColor: payments_pdf_generation_1.PAYMENTS_GREY,
                halign: "center",
                textColor: "#FFFFFF",
            },
            styles: {
                cellWidth: 60,
                fontSize: 7,
                textColor: payments_pdf_generation_1.PAYMENTS_BLACK,
                valign: "middle",
            },
            willDrawPage: (data) => {
                if (data.table.startPageNumber < data.pageNumber) {
                    data.table.head.splice(0, 1);
                }
            },
        });
        const createCustomerHeaderTable = () => {
            (0, payment_pdf_util_1.createPaymentActivityHeaderTable)(doc, dateLabel);
        };
        (0, payment_pdf_util_1.createHeader)(doc, "PAYMENT ACTIVITY", createCustomerHeaderTable);
        (0, payment_pdf_util_1.createFooter)(doc);
        return returnType === "BLOB" ? doc.output("blob") : doc;
    }
    catch (e) {
        console.error(e);
        throw new Error();
    }
};
PaymentsPDFGeneration.formatPaymentDetailsToPDFBlob = (paymentActivity, fileName, returnType = "BLOB", processedDate) => {
    try {
        const doc = (0, payment_pdf_util_1.createDoc)(fileName);
        paymentActivity.paymentDetails
            .slice()
            .sort((a, b) => {
            if (!a.userHasAccessToCust && b.userHasAccessToCust) {
                return 1;
            }
            else if (a.userHasAccessToCust && !b.userHasAccessToCust) {
                return -1;
            }
            else {
                return a.customerName.localeCompare(b.customerName);
            }
        })
            .forEach((detail, index, array) => {
            const customerHeader = detail.userHasAccessToCust
                ? (0, payment_pdf_util_1.composeCustomerDetailsHeader)(detail)
                : (0, payment_pdf_util_1.composeInaccessibleCustomerDetailsHeader)();
            const customerInvoiceRows = detail.userHasAccessToCust
                ? (0, payment_pdf_util_1.composeInvoiceDetailsRows)(detail)
                : (0, payment_pdf_util_1.composeInaccessibleCustomerInvoiceDetailsRows)(detail);
            const previousDetail = index > 0 ? array[index - 1] : null;
            const additionalMargin = !!previousDetail &&
                previousDetail.userHasAccessToCust &&
                !detail.userHasAccessToCust
                ? 10
                : 0;
            let startY = doc.previousAutoTable.finalY ?? 95;
            startY = startY + additionalMargin;
            const userOptions = {
                head: !previousDetail?.userHasAccessToCust &&
                    !detail.userHasAccessToCust
                    ? []
                    : customerHeader,
                startY,
                theme: "plain",
                margin: {
                    horizontal: 13,
                    top: 85,
                    bottom: 25,
                },
                rowPageBreak: "avoid",
                headStyles: !previousDetail?.userHasAccessToCust &&
                    !detail.userHasAccessToCust
                    ? {}
                    : {
                        fillColor: payments_pdf_generation_1.PAYMENTS_GREY,
                        halign: "center",
                        textColor: "#FFFFFF",
                    },
                styles: {
                    cellWidth: !previousDetail?.userHasAccessToCust &&
                        !detail.userHasAccessToCust
                        ? 420
                        : 140,
                    fontSize: 7,
                    textColor: payments_pdf_generation_1.PAYMENTS_BLACK,
                    valign: "middle",
                    halign: "center",
                    fontStyle: "bold",
                },
                tableLineColor: payments_pdf_generation_1.PAYMENTS_LIGHT_GRAY,
                tableLineWidth: 0.2,
                willDrawPage: (data) => {
                    if (data.table.startPageNumber < data.pageNumber) {
                        data.table.head.splice(0, 1);
                    }
                },
            };
            if (!!customerInvoiceRows) {
                userOptions.body = customerInvoiceRows;
            }
            (0, jspdf_autotable_1.default)(doc, userOptions);
        });
        const createCustomTable = () => {
            (0, payment_pdf_util_1.createPaymentDetailsHeaderTable)(doc, paymentActivity, processedDate);
        };
        (0, payment_pdf_util_1.createHeader)(doc, "PAYMENT DETAILS", createCustomTable);
        (0, payment_pdf_util_1.createFooter)(doc);
        return returnType === "BLOB" ? doc.output("blob") : doc;
    }
    catch (e) {
        console.error(e);
        throw new Error();
    }
};
PaymentsPDFGeneration.formatACHFormtoPDFBlob = (achForm, fileName, returnType = "BLOB") => {
    try {
        const doc = (0, payment_pdf_util_1.createDoc)(fileName);
        (0, payment_pdf_util_1.composeACHBody)(doc, achForm);
        (0, payment_pdf_util_1.createHeaderACH)(doc, "AUTOPAY DETAILS");
        (0, payment_pdf_util_1.createFooter)(doc);
        return returnType === "BLOB" ? doc.output("blob") : doc;
    }
    catch (e) {
        console.error(e);
        throw new Error();
    }
};
